export default class BaseComponent {
    constructor() {
        this.events = [];
    }

    addEvent(selector, eventName, callback) {
        this.events.push(this.element.find(selector).on(eventName, e => callback(e)));
    }

    childElements(selector) {
        if (this.element) {
            return this.element.find(selector);
        }

        return null;
    }

    domElement() {
        return this.element.get(0);
    }
}
